const productsData = [
  {
    id: 'sponsorship',
    title: 'La Dosis Positiva: Sponsorship de Estilo de Vida',
    product: 'Lifestyle & Wellness Sponsor',
    investment: '$80 / mes',
    impacts: [
      'Mención exclusiva como patrocinante del bloque de "Bienestar Diario".',
      'Presencia de marca en las transiciones y cortinas del segmento.',
      'Ubicación preferencial del producto físico en el set de grabación.',
      'Logo en la página del show en TNO Network (sección Anunciantes) con enlace dofollow.',
    ],
    image: '/images/yanirabocarandaladosispositiva.jpeg',
    imageAlt: 'La Dosis Positiva - Bienestar Diario',
  },
  {
    id: 'ugc',
    title: 'UGC Lab: Contenido Nativo Semanal',
    product: 'Plan Mensual UGC (4 piezas)',
    investment: '$100 / mes',
    subtitle: 'Incluye 1 pieza semanal',
    impacts: [
      'Entrega de una pieza de video semanal estilo "Storytelling" o "Life Hack" con el producto.',
      'Contenido orgánico, dinámico y optimizado para redes sociales (Reels/TikTok).',
      'Objetivo: Demostrar la versatilidad de Lácteos Barinas en el día a día del consumidor.',
    ],
    image: '/images/yaniraenlacocina.jpeg',
    imageAlt: 'Yanira en la cocina - UGC y contenido nativo',
    objectPosition: 'center top',
  },
  {
    id: 'rotativa',
    title: 'Plan Rotativa TNO: Frecuencia 24/7',
    product: 'Plan Rotativa Network',
    investment: '$180 / mes',
    impacts: [
      'Cuñas rotativas programadas cada hora en la radio digital.',
      'Presencia en la rotativa de la radio cada hora, las 24 horas del día.',
      'Difusión multiplataforma a través de nuestra Web y App oficial.',
    ],
    image: '/images/millennials_stream.jpg',
    imageAlt: 'TNO Network - Radio y streaming',
    bonificacion: [
      '4 historias en TNO Network (enlace dofollow).',
      'Banner en la página del programa (medida Glacier: 2001×701 px) con enlace dofollow.',
    ],
  },
];

export default productsData;
